// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetAccountShipToCollectionApiParameter } from "@insite/client-framework/Services/AccountService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { CustomAppState } from "@werner/App/Store/Reducers";

export function xngGetAccountShipTosDataView(
    state: ApplicationState,
    parameter?: GetAccountShipToCollectionApiParameter,
) {
    const dataView = (state as CustomAppState).xAccountShipTos.dataViews[getDataViewKey(parameter)];
    if (!dataView) {
        return {
            isLoading: false,
            pagination: null,
            value: undefined,
            properties: undefined,
            costCodesCollection: undefined,
        };
    }

    return dataView;
}
